import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_13',
  type: NAVBAR,
  name: 'Navbar 13',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_13.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#80B1D5',editable: true},
      color: {type: 'css', value: 'white', editable: true},
      padding: {type: 'css', value: '0.5rem 1rem', editable: true},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemHoverBorder: {type: 'custom', value: '#d4e8f7', editable: true},
      navItemActiveBorder: {type: 'custom', value: '#B0CEE4', editable: true},
      navItemPadding: {type: 'custom', value: '0.5rem 1rem', editable: true},
      navItemBorderRadius: {type: 'custom', value: '20px', editable: true},
      navItemActiveBorderThickness: {type: 'custom', value:'1.5px', editable: true },
      socialMedia: {type: 'custom', value: true, editable: true},
      facebookLink: {type: 'custom', value: 'facebook.com', editable: true},
      twitterLink: {type: 'custom', value: 'twitter.com', editable: true},
      linkedInLink: {type: 'custom', value: 'linkedin.com', editable: true},
      instagramLink: {type: 'custom', value: 'instagram.com', editable: true},
      socialMediaIconColor: {type: 'custom', value: 'white', editable: false},
    },
    contents: []
  }
}
